import { storage } from './storage.js';
import { me } from './me.js';

/**
 * Espaços do app. A mesma conta pode ser dono de veículo e fazer parte de uma empresa:
 *   personal  (azul)    Início · Garagem · Conta + Buscar
 *   business  (laranja) Painel · Veículos · Empresa · Conta + Receber veículo
 * Cada espaço tem o próprio início e as próprias abas; a troca fica no topo das telas e em Conta.
 * O espaço Empresa só existe para quem é membro de uma empresa. O app abre no último espaço usado
 * (no primeiro acesso, quem é profissional sem escolha salva abre na Empresa).
 */
const KEY = 'tc.space';

export const space = {
  /** Faz parte de uma empresa (tem o espaço Empresa). */
  get available() {
    return Boolean(me.current?.workshop);
  },

  /** @returns {'personal' | 'business'} */
  get current() {
    if (!this.available) return 'personal';
    const saved = storage.get(KEY);
    if (saved === 'business' || saved === 'personal') return saved;
    return me.current?.user?.role === 'MECHANIC' ? 'business' : 'personal';
  },

  set(value) {
    storage.set(KEY, value === 'business' ? 'business' : 'personal');
  },

  /** Tela inicial de um espaço. */
  home(value = this.current) {
    return value === 'business' ? '/workshop' : '/home';
  },

  isHome(path) {
    return path === '/home' || path === '/workshop';
  },
};
